import React, { useState } from "react";

const EnquiryToggle = () => {
  const [active, setActive] = useState("recommend");

  return (
    <div className="flex justify-center items-center">
      <div className="relative flex bg-gray-100 rounded-xl p-1 shadow-sm border border-gray-200">
        {/* Animated highlight background */}
        <div
          className={`absolute top-1 bottom-1 w-1/2 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-300 ease-in-out ${
            active === "recommend" ? "left-1" : "left-1/2"
          }`}
        ></div>

        {/* Recommend Button */}
        <button
          onClick={() => setActive("recommend")}
          className={`relative z-10 w-32 py-2 text-sm font-medium transition-all duration-200 rounded-lg ${
            active === "recommend"
              ? "text-white"
              : "text-gray-600 hover:text-gray-800"
          }`}
        >
          Recommend
        </button>

        {/* General Query Button */}
        <button
          onClick={() => setActive("query")}
          className={`relative z-10 w-32 py-2 text-sm font-medium transition-all duration-200 rounded-lg ${
            active === "query"
              ? "text-white"
              : "text-gray-600 hover:text-gray-800"
          }`}
        >
          General Query
        </button>
      </div>
    </div>
  );
};

export default EnquiryToggle;